import "./Experiencias.css";
import DbServer from "../../assets/experiencias/db.png";
import Unicred from "../../assets/experiencias/unicred.png";

const Experiencias = () => {
  return (
    <div id="experiencias" className="experiencias">
      <div className="containerExperiencias">
        <div className="dbServer">
          <a
            href="
            https://db.tec.br/ "
            target="_blank"
            rel="noreferrer"
          >
            <img alt="DB logo" src={DbServer} />
          </a>
          <div className="dbServerText">
            <h2>Full Stack Developer</h2>
            <h3> DB </h3>
            <p>
              Alocado dentro de uma unidade de negócios, atuo prestando
              outsourcing em outras empresas no desenvolvimento de WebApps.
            </p>
            <p>
              Além disso realizo modelagem de dados e manutenção de testes,
              tanto para produtos internos quanto externos.
            </p>
          </div>
        </div>
        <div className="unicred">
          <a
            href="https://www.unicred.com.br/home"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="Unicred logo" src={Unicred} />
          </a>
          <div className="unicredText">
            <h2> Front-End Developer</h2>
            <h3> Unicred</h3>
            <p>
              Desenvolvendo soluções Full Stack com React, Angular, WebCompoents e Java (Spring Boot), seguindo práticas de TDD, DDD e arquitetura de Microserviços e BFF. Já colaborei com o time de Design System, contribuindo para a criação e desenvolvimento do UDS (Unicred Design System), em parceria com designers e focado na experiência do usuário. Atualmente, integro o time de Crédito, onde trabalho no desenvolvimento de um novo serviço de financiamento.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experiencias;
